import { DesigntimeComponent } from './DesigntimeComponent.js'
import { LiquidString } from '../common/LiquidString.js'
import * as $ from 'jquery';

class Info extends DesigntimeComponent {
    static staticName = "Info";
    static staticId = "info";

    constructor(identifyer) {
        super(identifyer, 1);

        this.values = {
            header: new LiquidString("Default **header** text", `${this.id}_header`),
            text: new LiquidString("Default text", `${this.id}_text`),
            buttontext: { value: "Next" },
            imageurl: { value: "intro_game_changer.png", dontTranslate: true },
            imageclass: { value: "sid-image-circle", dontTranslate: true }
        };
    }

    getRuntimeView(context) {
        if (context.params.useBootstrapUi)
            return this.getRuntimeBootstrapView(context);

        let $view = $("<div></div>");
        if (this.values.imageurl.value) {
            var $imagebox = $("<div class='sid-question-image'></div>");
            $imagebox.append($("<img class='" + this.values.imageclass.value + "' src='" + context.getContentUrl() + this.values.imageurl.value + "'>"));
            $view.append($imagebox);
        }
        var textbox = $("<div class='sid-question-text'></div>");

        textbox.append(this.values.header.getTag("h3"));
        textbox.append(this.values.text.getTag("p"));
        $view.append(textbox);

        return $view;
    }

    getRuntimeBootstrapView(context) {
        let $view = $("<div class='mb-4 content-info'></div>");

        if (this.values.imageurl.value) {
            $view.append($("<img class='" + this.values.imageclass.value + " mb-4' src='" + context.getContentUrl() + this.values.imageurl.value + "'>"));
        }

        $view.append(this.values.header.getTag("h3"));
        $view.append(this.values.text.getTag("p"));

        return $view;
    }
}

export { Info }
